import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_reward_proto from './dcei_wildsky_reward_proto';
export class CommunityReward {
  get descriptor() {
    return CommunityReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasReward = false;
    this._reward = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasReward && !this._reward.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CommunityReward) {
      return value;
    }
    return CommunityReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new CommunityReward();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.reward != null) {
      result._hasReward = true;
      result._reward = dcei_wildsky_reward_proto.Reward.fromJson(json.reward);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasReward && !this._reward.isEmpty()) {
      result.reward = dcei_wildsky_reward_proto.Reward.toJson(this._reward);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_wildsky_reward_proto.Reward}
   */
  get reward() {
    return this._hasReward ? this._reward : dcei_wildsky_reward_proto.Reward.default;
  }
  get hasReward() {
    return this._hasReward;
  }
  setReward(path, value) {
    return {type: 'SET', path: path.concat(['reward']), value: value.toJson()};
  }
  deleteReward(path) {
    return {type: 'DELETE', path: path.concat(['reward'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CommunityReward(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CommunityReward(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CommunityReward(this);
              copy._hasReward = true;
              copy._reward = dcei_wildsky_reward_proto.Reward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReward) {
                return this;
              }
              const copy = new CommunityReward(this);
              copy._hasReward = false;
              copy._reward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasReward) {
            const copy = new CommunityReward(this);
            copy._hasReward = true;
            copy._reward = dcei_wildsky_reward_proto.Reward.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._reward.apply(type, path.slice(1), value);
          if (newValue === this._reward) {
            return this;
          }
          const copy = new CommunityReward(this);
          copy._reward = copy._reward.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CommunityReward} other
   * @returns {CommunityReward}
   */
  merge(other) {
    const copy = new CommunityReward(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasReward) {
      if (copy._hasReward) {
        copy._reward = copy.reward.merge(other.reward);
      } else {
        copy._reward = other._reward;
      }
      copy._hasReward = true;
    }
    return copy;
  }
}
CommunityReward.default = new CommunityReward();
class CommunityReward_Builder {
  constructor(value) {
    this._value = new CommunityReward(value);
  }
  build() {
    return new CommunityReward(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setReward(value) {
    this._value._hasReward = true;
    this._value._reward = value;
    return this;
  }
  deleteReward() {
    this._value._hasReward = false;
    this._value._reward = null;
    return this;
  }
}
CommunityReward.Builder = CommunityReward_Builder;
class CommunityReward_WithParent {
  /**
   * @param {CommunityReward} value
   * @param {CommunityReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CommunityReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasReward() {
    if (this._cachedHasReward === undefined) {
      if (this._value.hasReward) {
        this._cachedHasReward = true;
      } else {
        this._cachedHasReward = this._parent ? this._parent.hasReward : false;
      }
    }
    return this._cachedHasReward;
  }
  get reward() {
    if (!this._cachedReward) {
      if (this._value.hasReward) {
        this._cachedReward = new dcei_wildsky_reward_proto.Reward.WithParent(this._value.reward, this._parent && this._parent.hasReward ? this._parent.reward : null);
      } else {
        this._cachedReward = this._parent ? new dcei_wildsky_reward_proto.Reward.WithParent(dcei_wildsky_reward_proto.Reward.default, this._parent.reward) : dcei_wildsky_reward_proto.Reward.WithParent.default;
      }
    }
    return this._cachedReward;
  }
  update(current, parent) {
    const result = new CommunityReward_WithParent(current, parent);
    if (this._cachedReward && this._value.hasReward && current.hasReward) {
      if (this._value.reward === current.reward && this._parent === parent) {
        result._cachedReward = this._cachedReward;
      } else {
        result._cachedReward = this._cachedReward.update(current.reward, parent && parent.hasReward ? parent.reward : null);
      }
    }
    return result;
  }
}
CommunityReward_WithParent.default = new CommunityReward_WithParent(CommunityReward.default, null);
CommunityReward.WithParent = CommunityReward_WithParent;
class CommunityReward_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get reward() {
    if (!this._reward) {
      this._reward = {
        name: "reward",
        Name: "Reward",
        number: 2,
        protoType: 11,
        protoName: "reward",
        type: dcei_wildsky_reward_proto.Reward,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reward;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.reward,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReward",
        Name: "DummyOneofForReward",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CommunityReward.descriptor = new CommunityReward_Descriptor();
export class FriendSystemData {
  get descriptor() {
    return FriendSystemData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFriendLimit = false;
    this._friendLimit = null;
    this._giftRewardPatterns = [];
    this._hasGiftDailyResetTime = false;
    this._giftDailyResetTime = null;
    this._communityRewards = [];
  }
  isEmpty() {
    if (this._hasFriendLimit) return false;
    if (this._giftRewardPatterns.length > 0) return false;
    if (this._hasGiftDailyResetTime) return false;
    if (this._communityRewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FriendSystemData) {
      return value;
    }
    return FriendSystemData.fromJson(value);
  }
  static fromJson(json) {
    const result = new FriendSystemData();
    if (json.friendLimit != null) {
      result._hasFriendLimit = true;
      result._friendLimit = JsonToInt32.fromJson(json.friendLimit);
    }
    result._giftRewardPatterns = JsonToList(json.giftRewardPatterns, JsonToString);
    if (json.giftDailyResetTime != null) {
      result._hasGiftDailyResetTime = true;
      result._giftDailyResetTime = JsonToInt32.fromJson(json.giftDailyResetTime);
    }
    result._communityRewards = JsonToList(json.communityRewards, CommunityReward);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFriendLimit) {
      result.friendLimit = JsonToInt32.toJson(this._friendLimit);
    }
    if (this._giftRewardPatterns.length > 0) {
      result.giftRewardPatterns = ArrayToJson(this._giftRewardPatterns, JsonToString);
    }
    if (this._hasGiftDailyResetTime) {
      result.giftDailyResetTime = JsonToInt32.toJson(this._giftDailyResetTime);
    }
    if (this._communityRewards.length > 0) {
      result.communityRewards = ArrayToJson(this._communityRewards, CommunityReward);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get friendLimit() {
    return this._hasFriendLimit ? this._friendLimit : JsonToInt32.default;
  }
  get hasFriendLimit() {
    return this._hasFriendLimit;
  }
  setFriendLimit(path, value) {
    return {type: 'SET', path: path.concat(['friendLimit']), value};
  }
  deleteFriendLimit(path) {
    return {type: 'DELETE', path: path.concat(['friendLimit'])};
  }
  /**
   * @returns {string[]}
   */
  get giftRewardPatterns() {
    return this._giftRewardPatterns;
  }
  addGiftRewardPatterns(path, value) {
    return {type: 'ADD', path: path.concat(['giftRewardPatterns']), value};
  }
  setGiftRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['giftRewardPatterns']), value: ArrayToJson(value, JsonToString)};
  }
  setGiftRewardPatternsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['giftRewardPatterns', key]), value};
  }
  deleteGiftRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['giftRewardPatterns'])};
  }
  deleteGiftRewardPatternsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['giftRewardPatterns', key])};
  }
  /**
   * @returns {number}
   */
  get giftDailyResetTime() {
    return this._hasGiftDailyResetTime ? this._giftDailyResetTime : JsonToInt32.default;
  }
  get hasGiftDailyResetTime() {
    return this._hasGiftDailyResetTime;
  }
  setGiftDailyResetTime(path, value) {
    return {type: 'SET', path: path.concat(['giftDailyResetTime']), value};
  }
  deleteGiftDailyResetTime(path) {
    return {type: 'DELETE', path: path.concat(['giftDailyResetTime'])};
  }
  /**
   * @returns {CommunityReward[]}
   */
  get communityRewards() {
    return this._communityRewards;
  }
  addCommunityRewards(path, value) {
    return {type: 'ADD', path: path.concat(['communityRewards']), value: value.toJson()};
  }
  setCommunityRewards(path, value) {
    return {type: 'SET', path: path.concat(['communityRewards']), value: ArrayToJson(value, CommunityReward)};
  }
  setCommunityRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['communityRewards', key]), value: value.toJson()};
  }
  deleteCommunityRewards(path) {
    return {type: 'DELETE', path: path.concat(['communityRewards'])};
  }
  deleteCommunityRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['communityRewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "friendLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FriendSystemData(this);
              copy._hasFriendLimit = true;
              copy._friendLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFriendLimit) {
                return this;
              }
              const copy = new FriendSystemData(this);
              copy._hasFriendLimit = false;
              copy._friendLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "giftRewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FriendSystemData(this);
              copy._giftRewardPatterns = [];        for (let i of value) {
                copy._giftRewardPatterns.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new FriendSystemData(this);
              copy._giftRewardPatterns = copy._giftRewardPatterns.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._giftRewardPatterns.length === 0) {
                return this;
              }
              const copy = new FriendSystemData(this);
              copy._giftRewardPatterns = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._giftRewardPatterns.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new FriendSystemData(this);
              copy._giftRewardPatterns = copy._giftRewardPatterns.slice();
              copy._giftRewardPatterns[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new FriendSystemData(this);
              copy._giftRewardPatterns = copy._giftRewardPatterns.slice(0, path[1]).concat(copy._giftRewardPatterns.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._giftRewardPatterns.length) {
            return this;
          }
          const oldValue = this._giftRewardPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new FriendSystemData(this);
          copy._giftRewardPatterns = copy._giftRewardPatterns.slice();
          copy._giftRewardPatterns[key] = newValue;
          return copy;
        }
      }
      case "giftDailyResetTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FriendSystemData(this);
              copy._hasGiftDailyResetTime = true;
              copy._giftDailyResetTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGiftDailyResetTime) {
                return this;
              }
              const copy = new FriendSystemData(this);
              copy._hasGiftDailyResetTime = false;
              copy._giftDailyResetTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "communityRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FriendSystemData(this);
              copy._communityRewards = [];        for (let i of value) {
                copy._communityRewards.push(CommunityReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new FriendSystemData(this);
              copy._communityRewards = copy._communityRewards.concat([CommunityReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._communityRewards.length === 0) {
                return this;
              }
              const copy = new FriendSystemData(this);
              copy._communityRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._communityRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new FriendSystemData(this);
              copy._communityRewards = copy._communityRewards.slice();
              copy._communityRewards[path[1]] = CommunityReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new FriendSystemData(this);
              copy._communityRewards = copy._communityRewards.slice(0, path[1]).concat(copy._communityRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._communityRewards.length) {
            return this;
          }
          const oldValue = this._communityRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new FriendSystemData(this);
          copy._communityRewards = copy._communityRewards.slice();
          copy._communityRewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FriendSystemData} other
   * @returns {FriendSystemData}
   */
  merge(other) {
    const copy = new FriendSystemData(this);
    if (other._hasFriendLimit) {
      copy._hasFriendLimit = true;
      copy._friendLimit = other._friendLimit;
    }
    copy._giftRewardPatterns = this._giftRewardPatterns.concat(other._giftRewardPatterns);
    if (other._hasGiftDailyResetTime) {
      copy._hasGiftDailyResetTime = true;
      copy._giftDailyResetTime = other._giftDailyResetTime;
    }
    copy._communityRewards = this._communityRewards.concat(other._communityRewards);
    return copy;
  }
}
FriendSystemData.default = new FriendSystemData();
class FriendSystemData_Builder {
  constructor(value) {
    this._value = new FriendSystemData(value);
  }
  build() {
    return new FriendSystemData(this._value);
  }
  setFriendLimit(value) {
    this._value._hasFriendLimit = true;
    this._value._friendLimit = value;
    return this;
  }
  deleteFriendLimit() {
    this._value._hasFriendLimit = false;
    this._value._friendLimit = null;
    return this;
  }
  addAllGiftRewardPatterns(values) {
    this._value._giftRewardPatterns = this._value._giftRewardPatterns.concat(values);
    return this;
  }
  addGiftRewardPatterns(value) {
    this._value._giftRewardPatterns = this._value._giftRewardPatterns.concat([value]);
    return this;
  }
  setGiftRewardPatterns(index, value) {
    this._value._giftRewardPatterns = this._value._giftRewardPatterns.concat();
    this._value._giftRewardPatterns[index] = value;
    return this;
  }
  clearGiftRewardPatterns() {
    this._value._giftRewardPatterns = [];
    return this;
  }
  setGiftDailyResetTime(value) {
    this._value._hasGiftDailyResetTime = true;
    this._value._giftDailyResetTime = value;
    return this;
  }
  deleteGiftDailyResetTime() {
    this._value._hasGiftDailyResetTime = false;
    this._value._giftDailyResetTime = null;
    return this;
  }
  addAllCommunityRewards(values) {
    this._value._communityRewards = this._value._communityRewards.concat(values);
    return this;
  }
  addCommunityRewards(value) {
    this._value._communityRewards = this._value._communityRewards.concat([value]);
    return this;
  }
  setCommunityRewards(index, value) {
    this._value._communityRewards = this._value._communityRewards.concat();
    this._value._communityRewards[index] = value;
    return this;
  }
  clearCommunityRewards() {
    this._value._communityRewards = [];
    return this;
  }
}
FriendSystemData.Builder = FriendSystemData_Builder;
class FriendSystemData_WithParent {
  /**
   * @param {FriendSystemData} value
   * @param {FriendSystemData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FriendSystemData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFriendLimit() {
    if (this._cachedHasFriendLimit === undefined) {
      if (this._value.hasFriendLimit) {
        this._cachedHasFriendLimit = true;
      } else {
        this._cachedHasFriendLimit = this._parent ? this._parent.hasFriendLimit : false;
      }
    }
    return this._cachedHasFriendLimit;
  }
  get friendLimit() {
    if (this._cachedFriendLimit === undefined) {
      if (this._value.hasFriendLimit) {
        this._cachedFriendLimit = this._value.friendLimit;
      } else {
        this._cachedFriendLimit = this._parent ? this._parent.friendLimit : this._value.friendLimit;
      }
    }
    return this._cachedFriendLimit;
  }
  get selfGiftRewardPatterns() {
    return this._value.giftRewardPatterns;
  }
  get inherentGiftRewardPatterns() {
    if (!this._inherentGiftRewardPatterns) {
      this._inherentGiftRewardPatterns = this._parent ? this._parent.giftRewardPatterns : [];
    }
    return this._inherentGiftRewardPatterns;
  }
  get giftRewardPatterns() {
    if (!this._allGiftRewardPatterns) {
      this._allGiftRewardPatterns = this._parent ? this._parent.giftRewardPatterns.concat(this.selfGiftRewardPatterns) : this.selfGiftRewardPatterns;
    }
    return this._allGiftRewardPatterns;
  }
  get hasGiftDailyResetTime() {
    if (this._cachedHasGiftDailyResetTime === undefined) {
      if (this._value.hasGiftDailyResetTime) {
        this._cachedHasGiftDailyResetTime = true;
      } else {
        this._cachedHasGiftDailyResetTime = this._parent ? this._parent.hasGiftDailyResetTime : false;
      }
    }
    return this._cachedHasGiftDailyResetTime;
  }
  get giftDailyResetTime() {
    if (this._cachedGiftDailyResetTime === undefined) {
      if (this._value.hasGiftDailyResetTime) {
        this._cachedGiftDailyResetTime = this._value.giftDailyResetTime;
      } else {
        this._cachedGiftDailyResetTime = this._parent ? this._parent.giftDailyResetTime : this._value.giftDailyResetTime;
      }
    }
    return this._cachedGiftDailyResetTime;
  }
  get selfCommunityRewards() {
    if (!this._selfCommunityRewards) {
      this._selfCommunityRewards = [];
      for (let i of this._value.communityRewards) {
        this._selfCommunityRewards.push(new CommunityReward.WithParent(i, null));
      }
    }
    return this._selfCommunityRewards;
  }
  get inherentCommunityRewards() {
    if (!this._inherentCommunityRewards) {
      this._inherentCommunityRewards = this._parent ? this._parent.communityRewards : [];
    }
    return this._inherentCommunityRewards;
  }
  get communityRewards() {
    if (!this._allCommunityRewards) {
      this._allCommunityRewards = this._parent ? this._parent.communityRewards.concat(this.selfCommunityRewards) : this.selfCommunityRewards;
    }
    return this._allCommunityRewards;
  }
  update(current, parent) {
    const result = new FriendSystemData_WithParent(current, parent);
    if (this._selfCommunityRewards) {
      if (this._value.communityRewards === current.communityRewards) {
        result._selfCommunityRewards = this._selfCommunityRewards;
      } else {
        result._selfCommunityRewards = [];
        for (let i = 0; i < current.communityRewards.length; i++) {
          const oldValue = this._value.communityRewards[i];
          if (oldValue) {
            const oldCache = this._selfCommunityRewards[i];
            if (oldValue === current.communityRewards[i]) {
              result._selfCommunityRewards[i] = oldCache;
            } else {
              result._selfCommunityRewards[i] = oldCache.update(current.communityRewards[i], null);
            }
          } else {
            result._selfCommunityRewards[i] = new CommunityReward.WithParent(current.communityRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
FriendSystemData_WithParent.default = new FriendSystemData_WithParent(FriendSystemData.default, null);
FriendSystemData.WithParent = FriendSystemData_WithParent;
class FriendSystemData_Descriptor {
  get friendLimit() {
    if (!this._friendLimit) {
      this._friendLimit = {
        name: "friendLimit",
        Name: "FriendLimit",
        number: 1,
        protoType: 5,
        protoName: "friend_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._friendLimit;
  }
  get giftRewardPatterns() {
    if (!this._giftRewardPatterns) {
      this._giftRewardPatterns = {
        name: "giftRewardPatterns",
        Name: "GiftRewardPatterns",
        number: 2,
        protoType: 9,
        protoName: "gift_reward_patterns",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "RewardPatternNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._giftRewardPatterns;
  }
  get giftDailyResetTime() {
    if (!this._giftDailyResetTime) {
      this._giftDailyResetTime = {
        name: "giftDailyResetTime",
        Name: "GiftDailyResetTime",
        number: 3,
        protoType: 5,
        protoName: "gift_daily_reset_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds starting from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._giftDailyResetTime;
  }
  get communityRewards() {
    if (!this._communityRewards) {
      this._communityRewards = {
        name: "communityRewards",
        Name: "CommunityRewards",
        number: 11,
        protoType: 11,
        protoName: "community_rewards",
        type: CommunityReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._communityRewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.friendLimit,
        this.giftRewardPatterns,
        this.giftDailyResetTime,
        this.communityRewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFriendLimit",
        Name: "DummyOneofForFriendLimit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGiftDailyResetTime",
        Name: "DummyOneofForGiftDailyResetTime",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
FriendSystemData.descriptor = new FriendSystemData_Descriptor();
